/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  AppInstallationsControllerCreateMutationResponse,
  AppInstallationsControllerCreate401,
} from '../../types/AppInstallationsControllerCreate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { appInstallationsCreate } from '../../methods/appInstallationsCreate.ts';
import { useMutation } from '@tanstack/react-query';

export const appInstallationsCreateMutationKey = () => [{ url: '/api/app-installations' }] as const;

export type AppInstallationsCreateMutationKey = ReturnType<typeof appInstallationsCreateMutationKey>;

/**
 * {@link /api/app-installations}
 */
export function useAppInstallationsCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      AppInstallationsControllerCreateMutationResponse,
      ResponseErrorConfig<AppInstallationsControllerCreate401>,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? appInstallationsCreateMutationKey();

  return useMutation<
    AppInstallationsControllerCreateMutationResponse,
    ResponseErrorConfig<AppInstallationsControllerCreate401>,
    void,
    TContext
  >(
    {
      mutationFn: async () => {
        return appInstallationsCreate(config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
